import {
  HomePage,
  ConfigurationPage,
  DatePage,
  PatientsPage,
  SamplesPage,
  ResultsPage,
  BillingPage,
  ReportsPage,
  TraceabilityPage,
  WarningsPage,
  TrackingPage,
  SerumLibraryPage,
  AdminOrdersPage,
  BarcodesPage,
  ReferralsPage,
  FindResultsPage,
  MassPrintingPage,
  MassValidationPage,
  TimersPage,
  WorkListPage,
  ControlBoardsPage,
  DashboardsPage,
  AnalyzersPage,
  AnalitosPage,
  ConfigGeneralPage,
  ConfigQCPage,
  MeasurementsQC,
  MasiveMeasurementsQC,
  AlarmasPage,
  AnalitosPlantillasPage,
  AnalitosTiposMuestrasPage,
  AnalizadoresPage,
  ConfigBarcodesPage,
  ConfigCamposDinamicosPage,
  EstudiosPage,
  EstudiosPerfilesPage,
  ConfigPermisosPage,
  ConfigReportesPage,
  ConfigReportesInformesPage,
  ConfigReportesDisenadorPage,
  ConfigReportesDefinicionesPage,
  ConfigUsuariosPage,
  TareasOperativasPage,
  TareasOperativasCerrarOrdenesPage,
  TareasOperativasDisenosPage,
  Quotations,
  PreordersPage,
  ConfigFacturacionPage,
  ConexionesPage,
  ConfigTablasPage,
  ConfigAppoiments,
  AdminAgendaCitas,
  Cashier,
  FindPatientPage,
  ConfigNotasPage,
  MyProfilePage,
  ConfigWebPagePatientsPage,
  ConfigEmailTemplatesPage,
  ConfigInformedConsentsPage,
  ConfigBackupsPage,
  ExternalRemisionsPage,
 TraceabilityMasiveActionsPage
, AboutSynerLabPage
} from './pages/index.lazy';

import { withNavigationWatcher } from './contexts/navigation';

const routes = [
  {
    path: '/adminAgendaCitas',
    element: AdminAgendaCitas,
  },
  {
    path: '/configAgendaCitas',
    element: ConfigAppoiments,
  },
  {
    path: '/home',
    element: HomePage,
  },
  {
    path: '/configuration',
    element: ConfigurationPage,
  },
  {
    path: '/date',
    element: DatePage,
  },
  {
    path: '/patients',
    element: PatientsPage,
  },
  {
    path: '/samples',
    element: SamplesPage,
  },
  {
    path: '/results',
    element: ResultsPage,
  },
  {
    path: '/billing',
    element: BillingPage,
  },
  {
    path: '/quotations',
    element: Quotations,
  },
  {
    path: '/cashier',
    element: Cashier,
  },
  {
    path: '/reports',
    element: ReportsPage,
  },
  {
    path: '/traceability',
    element: TraceabilityPage,
  },
  {
    path: '/warnings',
    element: WarningsPage,
  },
  {
    path: '/tracking',
    element: TrackingPage,
  },
  {
    path: '/serum-library',
    element: SerumLibraryPage,
  },
  {
    path: '/admin-orders',
    element: AdminOrdersPage,
  },
  {
    path: '/barcodes',
    element: BarcodesPage,
  },
  {
    path: '/referrals',
    element: ReferralsPage,
  },
  {
    path: '/find-results',
    element: FindResultsPage,
  },
  {
    path: '/mass-printing',
    element: MassPrintingPage,
  },
  {
    path: '/mass-validation',
    element: MassValidationPage,
  },
  {
    path: '/timers',
    element: TimersPage,
  },
  {
    path: '/work-list',
    element: WorkListPage,
  },
  {
    path: '/control-boards',
    element: ControlBoardsPage,
  },
  {
    path: '/dashboards',
    element: DashboardsPage,
  },
  {
    path: '/analyzers',
    element: AnalyzersPage,
  },
  {
    path: '/analitos',
    element: AnalitosPage,
  },
  {
    path: '/config-general',
    element: ConfigGeneralPage,
  },
  {
    path: '/config-qc',
    element: ConfigQCPage,
  },
  {
    path: '/measurements-qc',
    element: MeasurementsQC,
  },
  {
    path: '/masive-measurements-qc',
    element: MasiveMeasurementsQC,
  },
  {
    path: '/alarmas',
    element: AlarmasPage,
  },
  {
    path: '/analitos-plantillas',
    element: AnalitosPlantillasPage,
  },
  {
    path: '/analitos-tipos-muestras',
    element: AnalitosTiposMuestrasPage,
  },
  {
    path: '/analizadores',
    element: AnalizadoresPage,
  },
  {
    path: '/configbarcodes',
    element: ConfigBarcodesPage,
  },
  {
    path: '/config-campos-dinamicos',
    element: ConfigCamposDinamicosPage,
  },
  {
    path: '/estudios',
    element: EstudiosPage,
  },
  {
    path: '/estudios-perfiles',
    element: EstudiosPerfilesPage,
  },
  {
    path: '/config-permisos',
    element: ConfigPermisosPage,
  },
  {
    path: '/config-reportes',
    element: ConfigReportesPage,
  },
  {
    path: '/config-reportes-informes',
    element: ConfigReportesInformesPage,
  },
  {
    path: '/config-reportes-disenador',
    element: ConfigReportesDisenadorPage,
  },
  {
    path: '/config-reportes-definiciones',
    element: ConfigReportesDefinicionesPage,
  },
  {
    path: '/config-usuarios',
    element: ConfigUsuariosPage,
  },
  {
    path: '/tareas-operativas',
    element: TareasOperativasPage,
  },
  {
    path: '/tareas-operativas-cerrar-ordenes',
    element: TareasOperativasCerrarOrdenesPage,
  },
  {
    path: '/tareas-operativas-disenos',
    element: TareasOperativasDisenosPage,
  },
  {
    path: '/preorders',
    element: PreordersPage,
  },
  {
    path: '/config-facturacion',
    element: ConfigFacturacionPage,
  },
  {
    path: '/conexiones',
    element: ConexionesPage,
  },
  {
    path: '/config-tablas',
    element: ConfigTablasPage,
  },
  {
    path: '/find-patient',
    element: FindPatientPage,
  },
  {
    path: '/config-notas',
    element: ConfigNotasPage,
  },
  {
    path: '/my-profile',
    element: MyProfilePage,
  },
  {
    path: '/config-web-page-patients',
    element: ConfigWebPagePatientsPage,
  },
  {
    path: '/config-email-templates',
    element: ConfigEmailTemplatesPage,
  },
  {
    path: '/config-informed-consents',
    element: ConfigInformedConsentsPage,
  },
  {
    path: '/config-backups',
    element: ConfigBackupsPage,
  },
  {
    path: '/external-remisions',
    element: ExternalRemisionsPage,
  },
  {
    path: '/traceability-masive-actions',
    element: TraceabilityMasiveActionsPage
  }
, 
  {
    path: '/about-syner-lab',
    element: AboutSynerLabPage
  }
];

export default routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
